import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }


  sendEmail(contact): Observable<any> {
    return this.http.post<any>(`${environment.apiURL}v1/sendContact`, contact);
  }
}
